module.exports = __webpack_public_path__ + "static/media/oppidum.d8927740.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/oppidum.png
// module id = 743
// module chunks = 0